export const LocalDateTimeToMMDDHH = (localDateTime) => {
  const splitText = localDateTime.split(' ');
  const date = splitText[0].split('-');
  const time = splitText[1].split(':');
  const month = date[1];
  const day = date[2];
  const hour = time[0];
  const response = month.concat('월 ', day, '일 ', hour, '시');
  return response;
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  let month = 1 + date.getMonth();
  month = month >= 10 ? month : '0' + month;
  let day = date.getDate();
  day = day >= 10 ? day : '0' + day;
  let hour = date.getHours();
  hour = hour >= 10 ? hour : '0' + hour;
  let min = date.getMinutes();
  min = min >= 10 ? min : '0' + min;

  const slashYMD = `${year}-${month}-${day}`;
  const fulldate = `${year}${month}${day}${hour}${min}`;
  const textYMD = `${year}년 ${month}월 ${day}일`;
  const fulldateWithText = `${textYMD} ${hour}시 ${min}분`;

  return { slashYMD, fulldate, textYMD, fulldateWithText };
};

export const calculateDateFromCurrent = ({ year = 0, month = 0, day = 0 }) => {
  const calculateYear = new Date(
    new Date().setFullYear(new Date().getFullYear() + year),
  );

  const calculateMonth = new Date(
    new Date().setMonth(new Date().getMonth() + month),
  );

  const calculateDay = new Date(new Date().setDate(new Date().getDate() + day));

  return { calculateYear, calculateMonth, calculateDay };
};
